import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { TurnstileService } from '../shared/services/turnstile.service';

interface InstallLookup {
  code: string;
  company: string;
  expires_at: string;
  redeemed: boolean;
}

// The customer types the install code the NCommerce team generated
// (Company.provision! on the server) and downloads the installer zip,
// which already carries the code.
@Component({
    selector: 'app-install',
    templateUrl: './install.component.html',
    styleUrls: ['./install.component.scss'],
    standalone: false
})
export class InstallComponent {
  // Same as InstallCode::LENGTH on the server.
  readonly codeLength = 8;
  code: string = '';
  loading: boolean = false;
  error: string = '';
  install: InstallLookup | null = null;

  constructor(private http: HttpClient, private turnstile: TurnstileService) { }

  normalizedCode(): string {
    return (this.code || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  lookup() {
    const code = this.normalizedCode();
    if (code.length !== this.codeLength || this.loading) {
      return;
    }
    this.loading = true;
    this.error = '';

    this.turnstile.getToken().then(
      token => this.postLookup(code, token),
      () => {
        this.loading = false;
        this.error = 'Não foi possível verificar o navegador. Atualize a página e tente de novo.';
      }
    );
  }

  downloadUrl(): string {
    return `${environment.server_url}/install/${this.install!.code}/download`;
  }

  reset() {
    this.install = null;
    this.code = '';
    this.error = '';
  }

  private postLookup(code: string, token: string) {
    this.http.post<InstallLookup>(`${environment.server_url}/install/lookup`, {
      code: code,
      cf_turnstile_response: token
    }).subscribe({
      next: res => {
        this.loading = false;
        this.install = res;
      },
      error: err => {
        this.loading = false;
        this.error = (err.error && err.error.errors && err.error.errors[0]) ||
          'Não foi possível consultar o código agora. Tente de novo em alguns minutos.';
      }
    });
  }
}
